var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  fill: "#7D7D7D",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "APP-KIT",
  transform: "translate(-274.000000, -1459.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(274.000000, 1459.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
  id: "Vector",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1056191,2.56998508 L3.74129019,8.13849933 L3.60829152,8.26288961 C3.10655713,8.768959 2.83400311,9.40640762 2.83333333,10.0717938 L2.83333333,17.8364445 L2.83840819,17.9900521 C2.94171846,19.4440203 4.26201391,20.5333645 5.82819343,20.5333645 L9.56096482,20.5333645 C9.89875049,20.5333645 10.1725946,20.259563 10.1726471,19.9217773 L10.1735209,14.3001257 L10.1784313,14.2112545 C10.2060996,13.9290391 10.4694299,13.6883483 10.7852033,13.6883483 L13.5814652,13.6883483 L13.6702412,13.6932587 C13.9524567,13.7209269 14.1931475,13.9842572 14.1931475,14.3000306 L14.1922737,19.9215871 C14.1922212,20.2594471 14.466096,20.5333645 14.803956,20.5333645 L18.538475,20.5333645 L18.7058346,20.5290356 C20.2824281,20.4431764 21.5333351,19.2824515 21.5333351,17.8364445 L21.5333351,10.0724093 L21.5264613,9.89651324 C21.4697571,9.21090268 21.1479563,8.59517642 20.6250941,8.13825081 L14.2702375,2.57786536 L14.095748,2.4406458 C12.9215627,1.5863257 11.2156248,1.63687815 10.1056191,2.56998508 Z M13.3759973,3.42987776 L13.4905192,3.51995516 L19.8197964,9.05918322 C20.108112,9.31114034 20.2775662,9.63537021 20.3057593,9.97316062 L20.3105137,10.0981806 L20.3099705,17.8364445 C20.3099705,18.5955203 19.5989169,19.2553117 18.6558404,19.3068073 L18.5218313,19.3102264 L15.4147644,19.3099999 L15.4165121,14.3001257 C15.4165121,13.3522303 14.6950918,12.5629529 13.7574682,12.4733575 L13.6105073,12.4656735 L10.7852033,12.4649837 C9.83740298,12.4649837 9.04812563,13.186404 8.9585302,14.1240276 L8.95084618,14.2709884 L8.94928252,19.3099999 L5.82819343,19.3099999 C4.87422648,19.3099999 4.11388903,18.6826637 4.05983669,17.9248022 L4.0563117,17.8147106 L4.05669794,10.0724093 C4.05703709,9.73562652 4.19839167,9.40502681 4.46167043,9.13917425 L4.5628366,9.04471019 L10.9020128,3.49854925 C11.5702559,2.93695889 12.6543711,2.90483306 13.3759973,3.42987776 Z",
  id: "Home",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIcon);
export default ForwardRef;